<section>
  <div class="cover-box">
    <div class="container">
      <div class="cover-wrap">
        <div>
          <h1 class="section-title">{{"cover.title" | translate}}</h1>
          <p>{{"cover.note1" | translate}}</p>
          <p>{{"cover.note2" | translate}}</p>
          <button mat-button="filled" class="main mt-15" (click)="onContactClicked()">{{"global.contactUs" | translate}}</button>
        </div>
        <img src="assets/svgs/cover.svg" alt="Cover"/>
      </div>
    </div>
  </div>
</section>
